import styled from '@emotion/styled'
import { Button } from '@retailer-platform/shared-components/src/tds'
import type { FunctionComponent } from 'react'
import { useDashMessages } from '../../../intl/intl.hooks'

type Props = {
  onClickAccept: () => void
  onClickCancel: () => void
}

const Container = styled.div({
  display: 'flex',
  marginLeft: 'auto',
  marginRight: '0px',
  marginTop: '4px',
  padding: '0px 8px 8px 8px',
  gap: '8px',
})

const ApplyCancelComponent: FunctionComponent<Props> = ({ onClickAccept, onClickCancel }) => {
  const intlMessages = useDashMessages({
    cancel: 'multiScopePicker.cancel',
    apply: 'multiScopePicker.apply',
  })
  return (
    <Container>
      <div css={{ marginLeft: 'auto', marginRight: '0px' }} />
      <Button
        data-testid="multi-scope-picker-cancel-button"
        variant="secondary"
        onClick={onClickCancel}
      >
        {intlMessages.cancel}
      </Button>
      <Button data-testid="multi-scope-picker-apply-button" onClick={onClickAccept}>
        {intlMessages.apply}
      </Button>
    </Container>
  )
}

export default ApplyCancelComponent
